import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Program ID for the circle */
  programId: number;
  /** Whether the user has access to circle content */
  hasAccess: boolean;
};

/**
 * Circle tab content for the Program page.
 * Shows circle information if user has access, otherwise shows coming soon message.
 */
export function CircleTabContent({ programId: _programId, hasAccess }: Props) {
  if (!hasAccess) {
    return (
      <OuterContentContainer className="flex flex-1" innerClassName="gap-8">
        <SectionHeading
          title="Your Peer Circle"
          description="Connect with the members of your peer circle."
        >
          <Type variant="body2">
            Peer cohorts will be matched on April 26. Then you'll be able to see who you matched with here.
          </Type>
        </SectionHeading>
      </OuterContentContainer>
    );
  }

  return (
    <OuterContentContainer className="flex flex-1" innerClassName="gap-8">
      <SectionHeading
        title="Your Peer Cohort"
        description="Connect with the members of your peer circle."
      >
        <Type variant="body2">
          Peer cohorts will be matched on April 26. Then you'll be able to see who you matched with here.
        </Type>
      </SectionHeading>
    </OuterContentContainer>
  );
}

export default CircleTabContent;
